import { createContext, useContext, useEffect, useState } from "react";
import { getData } from "~/helper/apiService";
import LoginForm from "../LoginForm";
import { ModalOverLayContext } from "./ModalOverLayProvider";

const LoginContext = createContext();

function LoginProvider({ children }) {
  const [loginStatus, setloginStatus] = useState(null);

  const checkLogin = async () => {
    try {
      const res = await getData("/login/check");
      if (res && res.is_login) {
        setloginStatus(res.user_id);
      }else{
        setloginStatus(null)
      }
    } catch (error) {
      console.error("Error Login", error);
    }
  };

  useEffect(() => {
    checkLogin();
  }, []);

  return (
    <LoginContext.Provider value={{ loginStatus, setloginStatus, checkLogin }}>
      {children}
    </LoginContext.Provider>
  );
}

export { LoginContext, LoginProvider };
